<template>
  <div
    class="va-surface va-surface-interactive va-section-row"
    role="button"
    tabindex="0"
    :aria-label="label"
    @click="$emit('select', section)"
    @keydown.enter.prevent="$emit('select', section)"
    @keydown.space.prevent="$emit('select', section)"
  >
    <v-icon class="va-icon" size="20" color="primary">
      {{ _icon(section.icon) }}
    </v-icon>
    <span class="va-section-row-name">{{ label }}</span>
    <vetalfa-pro-badge v-if="showPro"></vetalfa-pro-badge>
  </div>
</template>

<style>
.va-section-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 10px;
  text-align: left;
}

.va-section-row-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  color: #193153;
  /* Quebra só entre palavras. `break-word` é a rede de segurança para um
     nome muito longo, no lugar de estourar o card. */
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;
}
</style>

<script>
import ProBadge from "@/components/ProBadge.vue";
import sectionsEnum from "@/constants/sections.enum.js";

export default {
  name: "SectionRow",
  components: {
    "vetalfa-pro-badge": ProBadge,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    /** Usa o nome completo do catálogo em vez do rótulo curto. */
    fullName: {
      type: Boolean,
      default: false,
    },
    /** Selo PRO: já resolvido pelo pai (`!isPremium && section.pro`). */
    showPro: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.fullName
        ? this.section.name
        : sectionsEnum.getSectionLabel(this.section);
    },
  },
};
</script>
